import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { MainLayout } from '@/components/layouts/MainLayout';
import { HomePage } from '@/pages/HomePage';
import { ProductosPage } from '@/pages/ProductosPage';
import { QuienesSomosPage } from '@/pages/QuienesSomosPage';
import { ContactoPage } from '@/pages/ContactoPage';
import { V0ComponentsDemo } from '@/pages/V0ComponentsDemo';
import { NotFoundPage } from '@/pages/NotFoundPage';

/**
 * R2 - INBOCA routing configuration
 * Uses React Router v6 with layout-based routing
 */
const router = createBrowserRouter([
  {
    path: '/',
    element: <MainLayout />,
    errorElement: <NotFoundPage />,
    children: [
      {
        index: true,
        element: <HomePage />
      },
      {
        path: 'productos',
        element: <ProductosPage />
      },
      {
        path: 'quienes-somos',
        element: <QuienesSomosPage />
      },
      {
        path: 'contacto',
        element: <ContactoPage />
      },
      {
        path: 'v0-demo',
        element: <V0ComponentsDemo />
      }
    ]
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
]);

export function AppRouter() {
  return <RouterProvider router={router} />;
}
